import type { OnboardingVariant } from './deriveVariant';

export type ContactInfoRequirement = 'all' | 'email' | 'none';

export function contactInfoRequirementFor(variant: OnboardingVariant): ContactInfoRequirement {
  if (variant === 'enterpriseSub') return 'all';
  if (variant === 'individualSub') return 'email';
  return 'none';
}
